import ContactModel from "../models/ContactModel";
import request from "../shared/http";
import Contact from "../models/Contacts";
import Tags from "../models/Tags";
import appConfig from "../shared/js/app-config";

class ContactApiService {
  constructor() {
    this.endpoint = `/contacts/${appConfig.getServiceId()}`;
  }
  parseContact(item) {
    return {
      id: item.id,
      name: item.name.trim(),
      phoneNumber: item.phone_number.trim(),
      email: item.email?.trim() || "",
      company: item.company?.trim() || "",
      position: item.position?.trim() || "",
      tags: item.tags?.map((tag) =>( 
        new Tags()
        .setId(tag.id)
        .setName(tag.name)
        .setColor(tag.color)
      )) || [],
      notes: item.notes?.trim() || "",
      address: item.address?.trim() || "",
      website: item.website?.trim() || "",
      birthday: item.birthday || null,
      source: item.source || "manual",
      status: item.status || "active",
      createAt: item.created_at,
    }
  }

  serializeContact(model) {
    return {
      id: model.getId() || null,
      name: model.getName().trim(),
      phone_number: model.getPhoneNumber().trim(),
      email: model.getEmail(),
      company: model.getCompany(),
      position: model.getPosition(),
      tags: model.getTags(),
      notes: model.getNotes(),
      address: model.getAddress(),
      website: model.getWebsite(),
      birthday: model.getBirthday(),
      source: model.getSource(),
      status: model.getStatus(),
    }
  }

  // Create a new contact
  async createContact(contactData) {
    console.log('contactData', contactData);
    
    try {
      // Validate required fields
      if (!contactData.getName() || !contactData.getPhoneNumber()) {
        throw new Error("Name and phone are required fields");
      }
      const url = `/contacts/${appConfig.getServiceId()}`;
      const { data } = await request.post(url, this.serializeContact(contactData));
      return data;
    } catch (error) {
      console.error("Create contact error:", error);
      return {
        success: false,
        error: error.message || "Failed to create contact",
        details: "Network or validation error",
      };
    }
  }
   async updateContact(contactData) {
    try {
      if (!contactData.getName() || !contactData.getPhoneNumber()) {
        throw new Error("Name and phone are required fields");
      }
      const url = `/contacts/${appConfig.getServiceId()}`;
      const { data } = await request.put(url, this.serializeContact(contactData));
      return data;
    } catch (error) {
      console.error("Update contact error:", error);
      return {
        success: false,
        error: error.message || "Failed to update contact",
        details: "Network or validation error",
      };
    }
  }


  // Get all contacts with pagination and filters
  async getContactsDetails(params = {}) {
    try {
      const queryParams = {
        page: params.page || 1,
        limit: params.limit || 20,
        search: params.search || "",
        tags: params.tags || "",
        status: params.status || "",
        sortBy: params.sortBy || "created_at",
        sortOrder: params.sortOrder || "desc",
      };
      const url = `/contacts/${appConfig.getServiceId()}`;
      const { data } = await request.get(url, queryParams);
      console.log('contdata', data);
      
      return data.map((res) => new Contact(this.parseContact(res)));
      
    } catch (error) {
      console.error("Get contacts error:", error);
      return {
        success: false,
        error: error.message || "Failed to fetch contacts",
        details: "Network error",
      };
    }
  }

  // Get a single contact by ID
  async getContactById(id) {
    try {
      const response = await request.get(`${this.endpoint}/${id}`);

      if (response.success) {
        const contact = new ContactModel({
          id: response.data.id,
          name: response.data.name,
          phone: response.data.phone,
          email: response.data.email,
          company: response.data.company,
          position: response.data.position,
          tags: response.data.tags || [],
          notes: response.data.notes,
          address: response.data.address,
          website: response.data.website,
          birthday: response.data.birthday,
          source: response.data.source,
          status: response.data.status,
          createdAt: response.data.created_at,
          updatedAt: response.data.updated_at,
        });

        return {
          success: true,
          data: contact,
        };
      } else {
        return {
          success: false,
          error: response.error || "Failed to fetch contact",
          details: response.data?.message || "Contact not found",
        };
      }
    } catch (error) {
      console.error("Get contact error:", error);
      return {
        success: false,
        error: error.message || "Failed to fetch contact",
        details: "Network error",
      };
    }
  }
  // Delete a contact
  async deleteContact(id) {
    try {
      const response = await request.delete(`${this.endpoint}/${id}`);

      if (response.success) {
        return {
          success: true,
          message: "Contact deleted successfully",
        };
      } else {
        return {
          success: false,
          error: response.error || "Failed to delete contact",
          details: response.data?.message || "Unknown error occurred",
        };
      }
    } catch (error) {
      console.error("Delete contact error:", error);
      return {
        success: false,
        error: error.message || "Failed to delete contact",
        details: "Network error",
      };
    }
  }

  // Bulk delete contacts
  async deleteContacts(ids) {
    try {
      const response = await request.post(`${this.endpoint}/bulk-delete`, { ids });

      if (response.success) {
        return {
          success: true,
          message: `${response.data.deleted_count} contacts deleted successfully`,
          deletedCount: response.data.deleted_count,
        };
      } else {
        return {
          success: false,
          error: response.error || "Failed to delete contacts",
          details: response.data?.message || "Unknown error occurred",
        };
      }
    } catch (error) {
      console.error("Bulk delete contacts error:", error);
      return {
        success: false,
        error: error.message || "Failed to delete contacts",
        details: "Network error",
      };
    }
  }

  // Import contacts from file
  async importContacts(file, options = {}) {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("options", JSON.stringify(options));

      const response = await fetch(`${this.baseURL}${this.endpoint}/import`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this.getAuthToken()}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      return {
        success: true,
        data: {
          imported: data.imported_count,
          failed: data.failed_count,
          errors: data.errors || [],
        },
        message: `Successfully imported ${data.imported_count} contacts`,
      };
    } catch (error) {
      console.error("Import contacts error:", error);
      return {
        success: false,
        error: error.message || "Failed to import contacts",
        details: "Network or file processing error",
      };
    }
  }

  // Export contacts
  async exportContacts(format = "csv", filters = {}) {
    try {
      const response = await request.post(`${this.endpoint}/export`, {
        format,
        filters,
      });

      if (response.success) {
        return {
          success: true,
          data: {
            downloadUrl: response.data.download_url,
            expiresAt: response.data.expires_at,
          },
          message: "Export completed successfully",
        };
      } else {
        return {
          success: false,
          error: response.error || "Failed to export contacts",
          details: response.data?.message || "Unknown error occurred",
        };
      }
    } catch (error) {
      console.error("Export contacts error:", error);
      return {
        success: false,
        error: error.message || "Failed to export contacts",
        details: "Network error",
      };
    }
  }
}

export default new ContactApiService();
